import React, { useState, useEffect } from 'react';
import './Loader.css';
// Import the logo
import logo from '../components/images/logo/logo-last.svg';

const Loader = ({ minLoaderTime = 2000 }) => {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Track when all content has been loaded
    const handleContentLoaded = () => {
      // We enforce a minimum loader display time for better UX
      setTimeout(() => {
        setFadeOut(true);
        
        // Allow time for fade-out animation before removing the loader
        setTimeout(() => {
          setLoading(false);
        }, 600); // Match this with CSS transition time
      }, minLoaderTime);
    };

    // Start loading sequence when component mounts
    const timer = window.setTimeout(handleContentLoaded, 100);

    // Check if window content is already loaded (cached pages)
    if (document.readyState === 'complete') {
      handleContentLoaded();
      clearTimeout(timer);
    } else {
      window.addEventListener('load', handleContentLoaded);
    }

    return () => {
      window.removeEventListener('load', handleContentLoaded);
      clearTimeout(timer);
    };
  }, [minLoaderTime]);

  // Add overflow hidden to body when loader is showing
  useEffect(() => {
    if (loading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [loading]);

  if (!loading) return null;

  return (
    <div className={`loader-wrapper ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loader-content">
        <div className="loader-logo">
          <img src={logo} alt="Hellink Tattoo" />
        </div>
        <div className="loader-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader; 